var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRentalPortal = function SvgRentalPortal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 56,
    viewBox: "1 2.2 18 15.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2.2h14a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m.25 1.5a.75.75 0 0 0-.75.75v5.5c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-5.5a.75.75 0 0 0-.75-.75z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1.5,
    x: 4.6,
    y: 5.5,
    fill: "currentColor",
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    x: 4.6,
    y: 8,
    fill: "currentColor",
    rx: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 9.25,
    y: 12.2,
    fill: "currentColor",
    rx: 0.75
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRentalPortal);
export default ForwardRef;